import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  Typography,
  CardActionArea,
  Grid
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '20%',
    flexBasis: '20%',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '25%',
      flexBasis: '25%'
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '33%',
      flexBasis: '33%'
    }
  },
  card: {
    display: 'flex',
    border: '4px solid ' + theme.palette.background.default,
    borderRadius: 0,
    backgroundColor: '#FFFFFF'
  },
  cardSelected: {
    borderColor: theme.palette.primary.main,
    borderRadius: 4,
    boxShadow: '0 4px 4px',
    backgroundColor: theme.palette.background.default
  },
  cardContent: {
    height: '96px',
    display: 'flex',
    flexDirection: 'column'
  }
}));

const ItemCard = (props) => {
  const { selected, onSelect, title } = props;
  const classes = useStyles();

  return (
    <Grid item xs={2} className={classes.root}>
      <Card
        elevation={selected ? 3 : 0}
        variant={selected ? 'outlined' : undefined}
        className={classnames({ [classes.card]: true, [classes.cardSelected]: selected })}
      >
        <CardActionArea onClick={onSelect}>
          <CardContent className={classes.cardContent}>
            <Typography variant='subtitle1'>{title}</Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  );
};

ItemCard.propTypes = {
  flow: PropTypes.object,
  selected: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default ItemCard;
